import moment from 'moment'

export default {
  props: {
    baseUrl: {
      type: String
      // The JSONPlaceholder API is a fake API
      // basically a Lorem Ipsum JSON API.
    },
    endpoint: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    // Provide a filter to limit the
    // results of the API request.
    filter: {
      type: Object
    },
    transformer: {
      type: Function,
      default: (a) => a
    },
    timezone: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    data () {
      return this.transformer(this.response)
    }
  },
  data () {
    return {
      // Create a new axios instance.
      // See: https://github.com/axios/axios#creating-an-instance
      api: this.$axios,
      response: null,
      error: null,
      loading: false
    }
  },
  watch: {
    // Load the data from the given endpoint
    // on initial rendering of the component and
    // every time the filter property changes.
    filter: {
      immediate: true,
      deep: true,
      handler: 'load'
    }
  },
  methods: {
    // The `query` method will handle
    // different query types for us.
    async query (type, ...params) {
      // If we're currently loading content
      // we don't submit an additional request.
      if (this.loading) return

      this.loading = true
      try {
        const response = await this.api[type](...params)
        this.response = response.data
        this.error = null
        this.$emit('success', response)

        if (this.endpoint.includes('run-test')) {
          let responseArray = Array.from(response.data.data)
          let lastItem = responseArray.pop()
          if (lastItem.end_conversation) {
            this.$emit('closePullingEvent')
          }
        }
      } catch (error) {
        this.response = null
        this.error = error.response
        this.$emit('error', error)
      }
      this.loading = false
    },
    load () {
      // Do not mutate the filter prop (deep watch would trigger another load)
      const params = {
        ...(this.filter || {})
      }
      const timezoneKey = this.timezone ? 'timezone' : 'time_zone'
      params[timezoneKey] = moment().format('Z')

      return this.query('get', this.endpoint, { params })
    }
  },
  render () {
    // Render the default scoped slot and
    // provide data and method properties
    // via the slot scope.
    return this.$scopedSlots.default({
      data: this.data,
      originalData: this.response,
      error: this.error,
      load: this.load,
      loading: this.loading
    })
  }
}
